import React from 'react'

import HowToDialog from 'components/HowToDialog'

import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles'

interface Props {
  open: boolean
  onClose: () => void
  iconUrl: string
  title: React.ReactNode
  message: React.ReactNode
  buttonLabel: React.ReactNode
}

const styles = createStyles({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 80,
    height: 80,
    background: '#fff',
    borderRadius: '50%',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const HelpLayer: React.SFC<InjectedProps> = ({
  classes,
  iconUrl,
  title,
  message,
  buttonLabel,
  open,
  onClose,
}) => (
    <HowToDialog
      open={open}
      onClose={onClose}
      variant="light"
      icon={(
        <div className={classes.iconContainer}>
          <img alt="" src={iconUrl} />
        </div>
      )}
      headline={title}
      message={message}
      actionLabel={buttonLabel}
      displayFAQ
    />
  )

export default withStyles(styles)(HelpLayer)
